<template>
<b-container
  class="d-flex section border-top border-muted"
  style="background-color: #08034c;"
  fluid
  >
  <b-row class="m-auto text-center justify-content-center">
    <b-col>
      <b-container
	class="px-3 p-sm-5 text-light text-center"
	fluid
	>
	<b-row>
	  <b-col class="px-0 px-xl-3 py-5">
	    <div class="d-inline-block mx-auto">
	      <slot name="content">
		<div class="d-flex">
		  <b-img
		    :src="require('../assets/trinapp_crosslink.png')"
		    class="mr-4"
		    style="height: 60px;"
		    />
		  <h1 class="my-auto">Crosslink</h1>
		</div>
		<div class="d-flex">
		  <b-img
		    :src="require('../assets/trinapp_cde.png')"
		    class="mr-4"
		    style="height: 60px;"
		    />
		  <h1 class="my-auto">+ TrinApp CDE</h1>
		</div>	
		<div class="d-flex">
		  <b-img
		    :src="require('../assets/trinpod_secure.png')"
		    class="mr-4"
		    style="height: 60px;"
		    />
		  <h1 class="my-auto">+ TrinPod<sup>&trade;</sup></h1>
		</div>
	      </slot>
	    </div>
	  </b-col>
	</b-row>
	<b-row>
	  <b-col class="py-3">
	    <p>Get it as a bundle</p>
	    <b-button
	      size="lg"
	      class="btn-orange"
	      href="https://trinpod.us/pricing?industry=construction"
	      >
	      Get Started
	    </b-button>
	  </b-col>
	</b-row>
	<b-row>
	  <b-col class="py-5">
	    <p>Or Build on the TrinPod<sup>&trade;</sup> you already have.</p>
	    <b-button
	      size="lg"
	      class="btn-yellow"
	      href="https://forms.zohopublic.com/graphmetrix/form/TrinPodandTrinAppCDEEarlyAccess/formperma/GuNJp8xKOxKKLgQzWzZNpHBwr5ap857uuxKRXLHp0IM"
	      target="_blank"
	      >
	      Build on Current
	    </b-button>
	  </b-col>
	</b-row>
      </b-container>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    name: "GetBundle"
}
</script>

<style scoped>
@media (max-width: 575px) {
    h1 {
	font-size: 1.65rem !important;
    }
}
</style>
